
try {
  process.dlopen(module, __dirname + require("path").sep + __webpack_public_path__ + "0155f3375e9f6508bf5bfb1b56005f1b.node");
} catch (error) {
  throw new Error('node-loader:\n' + error);
}
